export const RecentlyViewedClubStorageKey = {
  clubId: 'RecentlyViewedClubId',
  searchClubId: 'RecentlyViewedSearchClubId',
} as const;
